import Hero from "../components/Hero";
import { VideoPlayer } from "../components/VideoPlayer";
import { SponsorsGrid } from "../components/Sponsors";
import { StatementsGrid } from "../components/StatementsGrid";

export default function Home() {
  const videoUrl = "/videos/home_page/enercity_duoday_2025_720.mp4";

  return (
    <>
      <Hero image="../Hero_Home_Compressed.jpg" />
      <h2>Was ist der DUOday?</h2>
      <p>
        Der DUOday ist ein Aktionstag für mehr Inklusion im Arbeitsleben.
        Menschen mit Beeinträchtigungen bilden an diesem Tag ein „DUO“ mit
        Mitarbeitenden aus Unternehmen oder Verwaltungen und erhalten praxisnahe
        Einblicke in verschiedene Berufsfelder. Ziel ist es, gegenseitiges
        Verständnis zu fördern, Vorurteile abzubauen und Perspektiven für
        inklusive Beschäftigung zu schaffen.
      </p>

      <StatementsGrid
        headline="Statements"
        subline="Unsere Unterstützer:innen des DUOdays"
        items={[
          {
            title: "Eefje Pompen",
            quote:
              '"Der DUOday in Hannover zeigt eindrucksvoll, wie wichtig gelebte Inklusion im Arbeitsalltag ist. Das Engagement der vielen Beteiligten und Unterstützer:innen macht Mut und trägt dazu bei, unsere Arbeitswelt nachhaltiger und vielfältiger zu gestalten. Als Initiatorin und Organisatorin des DUOday freuen wir uns, auch in diesem Jahr ein Zeichen für das Miteinander von Menschen mit und ohne Behinderung zu setzen und neue Perspektiven zu eröffnen."',
            role: "Personalvorständin",
            org: "enercity",
            imageSrc: "/Eefje-Pompen.jpg",
            imageAlt:
              "Portrait von Eefje Pompen, Personalvorständin der enercity AG",
          },
          {
            title: "Jens Palandt",
            quote:
              '"der DUOday steht für Begegnung, Offenheit und neue Perspektiven. Menschen mit Beeinträchtigungen haben an diesem Tag die Möglichkeit, Arbeitsbereiche kennenzulernen, Kontakte zu knüpfen und Einblicke in den Berufsalltag zu gewinnen – ganz ohne Leistungsdruck, sondern auf Augenhöhe. Ich freue mich sehr, dass der DUOday in diesem Jahr weiter gewachsen ist: Rund 150 DUOs nehmen 2026 teil. Gemeinsam mit 21 Unternehmen und Institutionen sowie sechs Werkstätten für behinderte Menschen setzen wir damit ein starkes Zeichen für Inklusion in der Stadt und Region Hannover. Auch die Region Hannover beteiligt sich erneut mit mehreren DUOs in der Verwaltung. Unsere Mitarbeitenden geben Einblicke in ganz unterschiedliche Aufgabenbereiche und zeigen, welche vielfältigen beruflichen Perspektiven eine moderne Verwaltung bieten kann. Für uns ist der DUOday eine wertvolle Gelegenheit, miteinander ins Gespräch zu kommen, Berührungsängste abzubauen und voneinander zu lernen. Als Schirmherr danke ich allen Beteiligten herzlich für ihr Engagement und wünsche allen DUOs einen spannenden, bereichernden Aktionstag am 20. Mai 2026."',
            role: "Erster Regionsrat",
            org: "Region Hannover",
            imageSrc: "/Jens-Palandt.jpg",
            imageAlt:
              "Portrait von Jens Palandt, Erster Regionsrat der Region Hannover",
          },
          {
            title: "Belit Onay",
            quote:
              '"Hannover ist eine Stadt der Vielfalt und steht für Inklusion. Der Duoday schafft neue Möglichkeiten und Perspektiven: Menschen mit Behinderungen können Arbeitsbereiche kennenlernen und Einblicke in verschiedene Arbeitsplätze erhalten. Die Stadt Hannover unterstützt dieses Projekt ausdrücklich, um den Weg für Teilhabe weiter zu ebnen, Berührungsängste und Barrieren abzubauen und Begegnungen auf Augenhöhe zu schaffen. Ich freue mich über das große Engagement aller Beteiligten und die vielen Unternehmen und Institutionen, die in Stadt und Region dabei sind und wünsche allen DUOs einen schönen Aktionstag."',
            role: "Oberbürgermeister",
            org: "Landeshauptstadt Hannover",
            imageSrc: "/Belit-Onay.jpg",
            imageAlt:
              "Portrait von Belit Onay, Oberbürgermeister der Landeshauptstadt Hannover",
          },
          {
            title: "Annetraud Grote",
            quote:
              '"Der DUOday zeigt, wie viel Potenzial in inklusiver Arbeit steckt. Wenn Menschen mit Behinderungen neue Arbeitsbereiche kennenlernen und Unternehmen Berührungsängste abbauen, profitieren alle davon. Der Erfolg des DUOday macht deutlich: Inklusion gelingt dort, wo Begegnung möglich wird – unkompliziert, praxisnah und auf Augenhöhe. Ich bin unendlich dankbar, die Idee des DUOday unterstützen zu dürfen!"',
            role: "Landesbeauftragte für Menschen mit Behinderungen",
            org: "",
            imageSrc: "/Annetraud-Grote.jpg",
            imageAlt:
              "Portrait von Annetraud Grote, Landesbeauftragte für Menschen mit Behinderungen",
          }
        ]}
      />
      <h2>DUOday in der Stadt und Region Hannover</h2>
      <p>
        Der DUOday wird in der Hannover sowie in der Region Hannover gemeinsam
        umgesetzt. Unternehmen, öffentliche Arbeitgeber und Organisationen
        öffnen ihre Türen und ermöglichen Begegnungen auf Augenhöhe.
      </p>
      <section style={{ padding: "60px 20px", backgroundColor: "#f8f8f8" }}>
        <div style={{ maxWidth: 1400, margin: "0 auto" }}>
          <VideoPlayer videoUrl={videoUrl} autoPlay={false} />
        </div>
      </section>

      <h2>Initiator</h2>
        <p>
          Der DUOday in Stadt und Region Hannover wird maßgeblich von enercity
          initiiert und vorangetrieben. Als Hauptinitiator setzt enercity ein
          starkes Zeichen für gesellschaftliche Verantwortung und engagiert sich
          aktiv für mehr Inklusion von Menschen mit Beeinträchtigungen im
          Arbeitsleben.
        </p>

      <h2>Schirmherrschaft</h2>
      <p>
        Der DUOday in Stadt und Region Hannover steht unter der gemeinsamen
        Schirmherrschaft von enercity, der Landeshauptstadt Hannover und der
        Region Hannover. Diese breite Unterstützung unterstreicht die besondere
        Bedeutung von Inklusion im Arbeitsleben und setzt ein klares gemeinsames
        Zeichen für mehr Teilhabe und Chancengleichheit für Menschen mit
        Beeinträchtigungen.
      </p>

      <section style={{ padding: "40px 20px" }}>
        <SponsorsGrid
          mainSponsors={[
            {
              name: "Landeshauptstadt Hannover",
              logoSrc: "../sponsors/LandeshauptstadtHannover.png",
            },
            {
              name: "enercity",
              logoSrc: "../sponsors/enercity.png",
              href: "https://www.enercity.de",
            },
            {
              name: "Region Hannover",
              logoSrc: "../sponsors/region-hannover.png",
            },
          ]}
          sponsorsRow2={[]}
          sponsorsRow3={[]}
        />{" "}
      </section>
    </>
  );
}

